export default {
    all: { method: 'GET', url: 'agenda' },
    get: { method: 'GET', url: 'agenda/get/{/id}' },
    create: { method: 'POST', url: 'agenda' },
    update: { method: 'PUT', url: 'agenda' },
    delete: { method: 'DELETE', url: 'agenda/{/id}' },
};